import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import withIntl from "../../utils/withIntl";
import IconButton from "@material-ui/core/IconButton";
import { Remove } from "@material-ui/icons";
import Button from "@material-ui/core/Button";
import EditTextFieldDialog from "../Dialogs/EditTextFieldDialog";
import { useDialog } from "../Dialogs/DialogProvider";
import DoneAllIcon from "@material-ui/icons/DoneAll";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";
import { Tooltip } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightBold,
    height: 40,
  },
  buttonText: {
    position: "absolute",
    padding: 0,
    left: 0,
    width: "100%",
    height: "100%",
    justifyContent: "flex-start",
  },
  listContainer: {
    display: "flex",
    flexWrap: "wrap",
    alignContent: "flex-start",
    margin: 5,
    overflowY: "scroll",
    height: 175,
    padding: 3,
    width: "100%",
  },
  section50: { width: "50%" },
  section100: { width: "100%", display: "flex", flexWrap: "wrap" },
  rootButton: { padding: 5, fontSize: 12, float: "right" },
  selectedSalesAreaContainer: { padding: 12, display: "flex", flexWrap: "wrap" },
  textButtonContainer: { width: "100%", position: "relative", verticalAlign: "center" },
}));

function SelectedSalesAreas(props) {
  const classes = useStyles();
  const [savedSelections, setSavedSelections] = React.useState(
    localStorage.getItem("savedSelections") ? JSON.parse(localStorage.getItem("savedSelections")) : []
  );
  const [openDialog] = useDialog();

  const handleSaveSalesAreasSelection = () => {
    const saveSelection = (name) => {
      let copySavedSelections = [...savedSelections];
      const index = copySavedSelections.map((selection) => selection.name).indexOf(name);
      const selectionObject = { name: name, items: [...props.selectedItems] };
      if (index == -1) {
        copySavedSelections.push(selectionObject);
      } else {
        copySavedSelections.splice(index, 1, selectionObject);
      }
      setSavedSelections(copySavedSelections);
    };
    openDialog({
      children: (
        <EditTextFieldDialog
          fieldTitle={props.intl.formatMessage({ id: "selection_name" })}
          handleOnClick={saveSelection}
          label={props.intl.formatMessage({ id: "selection_name" })}
        />
      ),
      fullWidth: true,
      maxWidth: "sm",
    });
  };

  const handleRemoveFromSavedSelections = (areasObject) => {
    const copySavedSelections = [...savedSelections];
    const index = copySavedSelections.map((selection) => selection.name).indexOf(areasObject.name);
    copySavedSelections.splice(index, 1);
    setSavedSelections(copySavedSelections);
  };

  useEffect(() => {
    localStorage.setItem("savedSelections", JSON.stringify(savedSelections));
  }, [savedSelections]);

  return (
    <div className={classes.selectedSalesAreaContainer}>
      <div className={classes.section50}>
        <Typography className={classes.heading}>{props.intl.formatMessage({ id: "saved_selections" })}</Typography>
        <div className={classes.listContainer}>
          {savedSelections.map((areasObject) => (
            <div key={areasObject.id + areasObject.type} className={classes.textButtonContainer}>
              <Button onClick={() => props.setSelectedItems(areasObject.items)} classes={{ root: classes.buttonText }}>
                {areasObject.name}
              </Button>
              <IconButton
                classes={{ root: classes.rootButton }}
                onClick={() => handleRemoveFromSavedSelections(areasObject)}
              >
                <RemoveCircleOutlineIcon />
              </IconButton>
            </div>
          ))}
        </div>
      </div>
      <div className={classes.section50}>
        <Typography className={classes.heading}>{props.intl.formatMessage({ id: "selected_sales_area" })}</Typography>
        <div className={classes.listContainer}>
          {props.selectedItems.map((item) => (
            <div key={item.id + item.type} className={classes.textButtonContainer}>
              <Typography variant={"caption"} classes={{ root: classes.buttonText }}>
                {item.renderedName}
              </Typography>
              <IconButton
                classes={{ root: classes.rootButton }}
                onClick={() => props.handleRemoveFromItems(item.renderedName)}
              >
                <Remove />
              </IconButton>
            </div>
          ))}
        </div>
        <div className={classes.section100}>
          <Tooltip title={props.intl.formatMessage({ id: "empty_selection" })}>
            <IconButton onClick={() => props.setSelectedItems([])} style={{ marginRight: "5px" }} variant="standard">
              <RemoveCircleOutlineIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title={props.intl.formatMessage({ id: "save_selection" })}>
            <IconButton onClick={handleSaveSalesAreasSelection} style={{ marginRight: "5px" }} variant="standard">
              <DoneAllIcon />
            </IconButton>
          </Tooltip>
        </div>
      </div>
    </div>
  );
}

export default withIntl(SelectedSalesAreas);
